import React from 'react';
import { Info } from 'lucide-react';

/**
 * Car Card Component for showing a car in the details panel
 * @param {Object} props - Component props
 * @param {string} props.carString - Car string (e.g. "#1 Alexander Calder")
 * @param {Object} props.carInfo - Car information object
 * @param {Function} props.onViewDetails - View details handler
 */
const CarCard = ({ carString, carInfo, onViewDetails }) => {
  return (
    <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
      {carInfo ? (
        <>
          {/* Car Image with overlay for details */}
          <div className="relative">
            <img 
              src={carInfo.image} 
              alt={`BMW Art Car by ${carInfo.artist}`}
              className="w-full h-48 object-cover"
              onError={(e) => {
                e.target.src = "/api/placeholder/400/200";
                e.target.alt = "Image not available";
              }}
              onClick={() => onViewDetails(carInfo)}
              style={{ cursor: 'pointer' }}
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
              <span className="inline-block px-3 py-1 bg-blue-800 text-white text-sm rounded-full mb-1">
                Car #{carInfo.number}
              </span>
              <h4 className="text-lg font-medium text-white">{carInfo.artist}</h4>
            </div>
          </div>
          
          {/* Car Details */}
          <div className="p-3">
            <div className="flex items-center justify-between">
              <p className="text-gray-800 font-medium">{carInfo.model}</p>
              <span className="text-sm text-gray-500">{carInfo.year}</span>
            </div>
            
            <div className="mt-2 text-sm text-gray-600">
              <button 
                onClick={() => onViewDetails(carInfo)}
                className="mt-2 text-blue-800 hover:text-blue-600 transition-colors flex items-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  <line x1="11" y1="8" x2="11" y2="14"></line>
                  <line x1="8" y1="11" x2="14" y2="11"></line>
                </svg>
                View details
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="p-5 text-gray-500 italic flex flex-col items-center justify-center">
          <div className="w-full h-32 bg-gray-200 flex items-center justify-center mb-3 rounded">
            <Info size={24} className="text-gray-400" />
          </div>
          <div className="text-center">
            <p>Car details to be announced</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CarCard;